import React from 'react'

function InfoCircle() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1057_121284)">
        <path d="M8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z" fill="#323232" />
        <path d="M8 11.6641V8.66406" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="1" cy="1" r="1" transform="matrix(1 0 0 -1 7 6)" fill="black" />
      </g>
      <defs>
        <clipPath id="clip0_1057_121284">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>

  )
}

export default InfoCircle